import { render, staticRenderFns } from "./hazopRelationDocu.vue?vue&type=template&id=651e7a17"
import script from "./hazopRelationDocu.vue?vue&type=script&lang=js"
export * from "./hazopRelationDocu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('651e7a17')) {
      api.createRecord('651e7a17', component.options)
    } else {
      api.reload('651e7a17', component.options)
    }
    module.hot.accept("./hazopRelationDocu.vue?vue&type=template&id=651e7a17", function () {
      api.rerender('651e7a17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/hazop/plan/hazopRelationDocu.vue"
export default component.exports